import { SpreadsheetOutput } from "./calculateSpreadsheetOutput";

export const GOOGLE_SHEET_ID = "1UWF1duV7IXAwdMatBTJCqlCTwRgLy3IofhQDzf-tfws"

export async function addSampleRow(): Promise<void> {
  await Post("https://www.cruxapp.ca/api/vegas/add_expense", {
    data: {
      date: "2025/03/04",
      cost_cad: 100,
      description: "Sample description",
      who_paid: "Nat",
      existing_share_group_name: "All",
    }
  });
}

export async function addExpense(spreadsheetOutput: SpreadsheetOutput): Promise<boolean> {
  const data = {
    date: spreadsheetOutput.date,
    cost_cad: spreadsheetOutput.cadTotal,
    cost_usd: spreadsheetOutput.usdTotal,
    description: spreadsheetOutput.description,
    who_paid: spreadsheetOutput.whoPaid,
    existing_share_group_name: spreadsheetOutput.existingShareName,
    new_share_group_name: spreadsheetOutput.customShare?.name,
    lyndon: spreadsheetOutput.customShare?.nameToShareMap["Lyndon"] ?? 0,
    angie: spreadsheetOutput.customShare?.nameToShareMap["Angie"] ?? 0,
    ben: spreadsheetOutput.customShare?.nameToShareMap["Ben"] ?? 0,
    lulu: spreadsheetOutput.customShare?.nameToShareMap["Lulu"] ?? 0,
    claudine: spreadsheetOutput.customShare?.nameToShareMap["Claudine"] ?? 0,
    jenny: spreadsheetOutput.customShare?.nameToShareMap["Jenny"] ?? 0,
    kevin: spreadsheetOutput.customShare?.nameToShareMap["Kevin"] ?? 0,
    bruce: spreadsheetOutput.customShare?.nameToShareMap["Bruce"] ?? 0,
    dom: spreadsheetOutput.customShare?.nameToShareMap["Dom"] ?? 0,
    josh: spreadsheetOutput.customShare?.nameToShareMap["Josh"] ?? 0,
    matt: spreadsheetOutput.customShare?.nameToShareMap["Matt"] ?? 0,
    nat: spreadsheetOutput.customShare?.nameToShareMap["Nat"] ?? 0,
    austin: spreadsheetOutput.customShare?.nameToShareMap["Austin"] ?? 0,
    howard: spreadsheetOutput.customShare?.nameToShareMap["Howard"] ?? 0,
    jason: spreadsheetOutput.customShare?.nameToShareMap["Jason"] ?? 0,
    michael: spreadsheetOutput.customShare?.nameToShareMap["Michael"] ?? 0,
    niko: spreadsheetOutput.customShare?.nameToShareMap["Niko"] ?? 0,
    jordan: spreadsheetOutput.customShare?.nameToShareMap["Jordan"] ?? 0,
  }

  interface Result {
    success: boolean;
  }
  const response = await Post<Result>("https://www.cruxapp.ca/api/vegas/add_expense", {
    data: data
  });

  return response.success;
}

async function Post<T>(route: string, body?: object): Promise<T> {
  if (body === null || body === undefined) body = {};

  return fetch(route, {
    method: "POST",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  }).then((response) => {
    if (!response.ok) {
      return response.text().then((text) => {
        throw new Error(text);
      });
    } else {
      return response.json();
    }
  });
}
